/* VALIDATORS */
import {isValidPhoneNumber} from 'libphonenumber-js';
import {isValid as isValidEmail} from 'mailchecker';
import * as IBAN from 'iban';
import BIC from 'bic';
import {helpers} from '@vuelidate/validators';

/* MIXINS */
import pwdRulesMixin from '@mixins/pwdRulesMixin';

export const roomValidator = (value) => {
  return value.zoneId !== undefined;
};

export const mustBeCool = (value) => {
  return value !== null;
};

/*
 * Variantes de minLength/maxLength qui ignorent les espaces en fin de chaîne
 */
export const minLengthTrimEnd = (min) =>
  helpers.withParams(
    {type: 'minLength', min},
    (value) => !helpers.req(value) || value.replace(/\s+$/, '').length >= min,
  );

export const maxLengthTrimEnd = (max) =>
  helpers.withParams(
    {type: 'maxLength', max},
    (value) => !helpers.req(value) || value.replace(/\s+$/, '').length <= max,
  );

export default {
  mixins: [pwdRulesMixin],
  methods: {
    phoneValidator(value) {
      return !value || isValidPhoneNumber(value);
    },

    emailValidator(value) {
      return !value || isValidEmail(value);
    },

    /*
     * Regex de Yousign pour valider un nom / prénom de signataire
     */
    yousignValidator(value) {
      return (
        !value ||
        /^(?!\s)[0-9A-Za-zĄÀÁÂÃÄÅÇĆÈÉÊËĘÌÍÎÏŁÑŃÒÓÔÕÖŚÙÚÛÜÝŹŻąàáâãäåæçćèéêëęìíîïłñńòóôõöśùúûüýÿźżßĀāĂăĈĉĊċČčĎďĐđĒēĔĕĖėĚěĜĝĞğĠġĢģĤĥĦħĨĩĪīĬĭĮįİıĲĳĴĵĶķĸĹĺĻļĽľĿŀŅņŇňŉŊŋŌōŎŏŐőŒœŔŕŖŗŘřŜŝŞşŠšŢţŤťŦŧŨũŪūŬŭŮůŰűŲųŴŵŶŷŸŽžſøØÆȘșȚț`'()\- ]+(?<!\s)$/.test(
          value,
        )
      );
    },
    pwdValidator(value) {
      return !value || this.isValidPwd(value);
    },

    /* INFORMATIONS BANCAIRES */
    ibanValidator(value) {
      return !value || IBAN.isValid(value);
    },
    bicValidator(value) {
      return !value || BIC.isValid(value);
    },
    accommodationTitleHasTooManyUppercase(value) {
      const uppercaseCount = (value.match(/[A-Z]/g) || []).length;
      return uppercaseCount > 5 || /[A-Z]{4,}/.test(value);
    },
    textHasEmoji(value) {
      return /\p{Emoji_Presentation}|\p{Extended_Pictographic}️|\p{Regional_Indicator}/u.test(value);
    },
    /*
     * Combine les règles majuscules + emoji sous un seul customPattern
     * (AkInputText n'affiche un message que pour une clé "customPattern")
     */
    accommodationTitleValidator(value) {
      if (!value) return true;
      return !this.accommodationTitleHasTooManyUppercase(value) && !this.textHasEmoji(value);
    },
    accommodationTitleErrorMessage(value) {
      if (value && this.textHasEmoji(value)) {
        return `Le titre de l'annonce ne doit pas contenir d'emoji`;
      }
      return `Le titre de l'annonce ne doit pas contenir plus de 5 majuscules dont 3 d'affilée`;
    },
  },
};
